﻿import ApiClient from '../Clients/ApiClient';

const basePath = '/api/', endpoints = {
    myPagesStart: `/${window.__lfSettings.myPagesStartPageUrl}`,

    profile: `/${window.__lfSettings.profilePageUrl}`,

    metaData: `${basePath}insurance-data/`,

    insurancePreregistrations: `/${window.__lfSettings.preregistrationPageUrl}`,

    contentPage: (page) =>
        `ContentPage/?page=${page}`,

    contentSearchPage: (page, query) =>
        `${window.location.pathname}/ContentPage/?page=${page}&q=${query}`,

    insuranceGuide: (data) =>
        `${window.location.pathname}/result?data=${data}`,

    healthDeclaration: (insuranceName, objId) =>
        `/${window.__lfSettings.healthDeclarationPageUrl}?insuranceName=${insuranceName}${objId ? `&insuranceObjectId=${objId}` : ''}`,

    insurancePurchase: (insuranceGroupNames = null, preSelection = null, possessionId = null, preFilledValues = null) => 
        `/${window.__lfSettings.purchasePageUrl}` +
        `${insuranceGroupNames ? `?groups=${Array.isArray(insuranceGroupNames) ? insuranceGroupNames.join(',') : insuranceGroupNames}` : ''}` +
        `${preSelection ? `&selected=${Array.isArray(preSelection) ? preSelection.join(',') : preSelection}` : ''}` +
        `${possessionId ? `&possessionId=${possessionId}` : ''}` +
        `${preFilledValues ? `&preFilledValues=${encodeURIComponent(JSON.stringify(preFilledValues))}` : ''}`,

    coInsuredForm: (data) => 
        `${window.location.origin}` + `${data.url}`,

    managedPensionInsuranceSigning: (url, appId) =>
        `${url}?appId=${appId}`,

    //Call to endpoint api v2
    insuranceMetaData: `${basePath}v2/insurance-metadata/`,
}

let instance = null;
export default class LfWebService {
    constructor() {
        if (!instance) {
            this.client = new ApiClient({basePath: ''});
            instance = this; 
        }

        return instance; 
    }

    // url getters

    get myPagesStartUrl() {
        return endpoints.myPagesStart;
    }

    // url methods

    healthDeclarationUrl = (insuranceName, objId = null) => {
        return endpoints.healthDeclaration(insuranceName, objId); 
    }

    insurancePurchaseUrl = (insuranceGroupNames, selection, possessionId, preFilledValues = null) => {
        return endpoints.insurancePurchase(insuranceGroupNames, selection, possessionId, preFilledValues);
    }

    insurancePreregistrationsUrl = () => {
        return endpoints.insurancePreregistrations; 
    }

    profilePageUrl = () => {
        return endpoints.profile;
    }

    // web api calls 

    insuranceMetaData = () => {
        return this.client.get(endpoints.metaData);
    }

    contentPage = (page) => {
        return this.client.get(endpoints.contentPage(page));
    }

    contentSearchPage = (page, query) => {
        return this.client.get(endpoints.contentSearchPage(page, query));
    }

    //Web api calls to v2
    possessionsMetaData = () => {
        return this.client.get(endpoints.insuranceMetaData);
    }


    // redirects 
    
    myPages = () => {
        window.location.href = endpoints.myPagesStart;
    }

    insurancePreregistrations = () => {
        window.location.href = endpoints.insurancePreregistrations;
    }

    insuranceGuide = (data) => {
        window.location.href = endpoints.insuranceGuide(encodeURIComponent(btoa(JSON.stringify(data))));
    }

    insurancePurchase = (insuranceGroupName, selection, possessionId) => {
        window.location.href = endpoints.insurancePurchase(insuranceGroupName, selection, possessionId);
    }

    coinsuredFormConfirmation = (data) => {
        window.location.href = endpoints.coInsuredForm(data);
    }

    startApplicationSigning = (data) => {
        window.location.href = endpoints.managedPensionInsuranceSigning(data)
    }
}